import React, { useState } from 'react';
import VideoControllerUtils from '@/v2/components/controllers/VideoController/VideoControllerUtils';
import Video from '@/v2/components/media/video/Video';

const VideoSimple = (props) => {
    const [currentSrc, setSrc] = useState(null);

    let { src } = props;
    const { forceRemount, options } = props;
    const { onReady } = options;
    const newOptions = onReady
        ? {
              ...options,
              onReady: (controller) => {
                  onReady(controller);
              },
          }
        : options;

    let srcHls = '';
    let srcDash = '';

    if (src.indexOf('.mp4') === -1) {
        src = `${props.src}/fallback/index.mp4`;
        srcHls = `${props.src}/hls/index.m3u8`;
        srcDash = `${props.src}/dash/index.mpd`;
    }

    let keyProp = {};

    if (currentSrc !== src) {
        setSrc(src);
        keyProp = forceRemount ? { key: `video-unique-${new Date().getTime()}` } : {};
    }

    return (
        <div className="VideoSimple">
            <Video {...props} options={newOptions} src={src} srcHls={srcHls} srcDash={srcDash} data-testid="Video" {...keyProp} />
        </div>
    );
};

VideoSimple.propTypes = VideoControllerUtils.GetComponentPropTypes();
VideoSimple.defaultProps = VideoControllerUtils.GetComponentDefaultProps();

export default VideoSimple;
